function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M35.984 31.285l9.428 9.215H14.588l9.428-9.215L30 35.449l5.984-4.164zM46.5 23.93v15.507l-9.247-9.038L46.5 23.93zm-33 0l9.247 6.469-9.247 9.038V23.93zm33-4.43v2.658L30 33.678l-16.5-11.52V19.5h33z"
});

function SvgEmailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+CiAgPHBhdGggZmlsbD0iZ3JheSIgZD0iTTM1Ljk4NCAzMS4yODVsOS40MjggOS4yMTVIMTQuNTg4bDkuNDI4LTkuMjE1TDMwIDM1LjQ0OWw1Ljk4NC00LjE2NHpNNDYuNSAyMy45M3YxNS41MDdsLTkuMjQ3LTkuMDM4TDQ2LjUgMjMuOTN6bS0zMyAwbDkuMjQ3IDYuNDY5LTkuMjQ3IDkuMDM4VjIzLjkzem0zMy00LjQzdjIuNjU4TDMwIDMzLjY3OGwtMTYuNS0xMS41MlYxOS41aDMzeiIvPgo8L3N2Zz4K";
export { SvgEmailinline as ReactComponent };